import { render, staticRenderFns } from "./GuanLiDian.vue?vue&type=template&id=263b78fc&scoped=true"
import script from "./GuanLiDian.vue?vue&type=script&lang=js"
export * from "./GuanLiDian.vue?vue&type=script&lang=js"
import style0 from "./GuanLiDian.vue?vue&type=style&index=0&id=263b78fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263b78fc",
  null
  
)

export default component.exports